import type { ReactNode } from 'react';
import styles from '../Dashboard.module.scss';

export type DashboardStatTone = 'gold' | 'green' | 'amber' | 'rose' | 'slate';

interface DashboardStatCardProps {
  label: string;
  value: string;
  hint?: string;
  icon: ReactNode;
  tone?: DashboardStatTone;
  featured?: boolean;
}

export function DashboardStatCard({
  label,
  value,
  hint,
  icon,
  tone = 'gold',
  featured = false,
}: DashboardStatCardProps) {
  return (
    <div className={`${styles.kpiCard} ${styles[`kpi_${tone}`]} ${featured ? styles.kpiFeatured : ''}`}>
      <div className={styles.kpiIcon}>{icon}</div>
      <div className={styles.kpiContent}>
        <span className={styles.kpiLabel}>{label}</span>
        <span className={styles.kpiValue}>{value}</span>
        {hint ? <span className={styles.kpiHint}>{hint}</span> : null}
      </div>
    </div>
  );
}
